import { PrivilegeIcon } from '../atoms/privilegeIcon';
import './../../resources_membership_hotel/css/hotel/membership_reserve_cancel.css'

export const PrivilegeUseComf = (props) => {
    const { data } = props;

    //yyyy-mm-ddをyyyy年mm月dd日(曜日)形式に変換
    const dateForm = (res) => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        let convert;
        if(res !== undefined && res !== null && res !== ""){
            var dateArr = res.split("-")
            let date = new Date(dateArr[0],dateArr[1] - 1,dateArr[2]);
            convert = dateArr[0]+ "年" +dateArr[1].replace(/^0+/, '')+ "月" + dateArr[2].replace(/^0+/, '')+ "日" + "(" +  youbi[date.getDay()]+ ")";
        }
        return convert;
    }

    return (
        <div>
            {data !== undefined && data.length !== 0 ?  data.map((value, index) => (
                <div className='membership_reserve_cancel_contentarea'>
                    {index === 0 ?
                    <div className='membership_reserve_cancel_title'>権利消化</div>
                    :
                    <div className='membership_reserve_cancel_title no_margin'/>
                    }
                    <div className='membership_reserve_cancel_body'>
                        <div className='membership_reserve_cancel_wid str_padding'>
                            <div className='membership_reserve_cancel_subtitle block sp_label'>{value.dayCnt}泊目</div>
                            <div className='membership_reserve_cancel_info full_width'>
                                <PrivilegeIcon className={value.shokaKenriIro}/>
                                <div>{dateForm(value.riyoDate)}</div>
                            </div>
                        </div>
                        <div className='membership_reserve_cancel_wid five_padding'>
                            <div className='membership_reserve_cancel_subtitle block sp_label'>権利消化</div>
                            <div className='membership_reserve_cancel_info full_width'>
                                <div>
                                    {value.shokaList.map((shoka, index) => (
                                        shoka.senyuDatHyojiOkFlg ?
                                        <div className='membership_reserve_cancel_privilege full_width'>
                                            <PrivilegeIcon className={shoka.shokaKenriIro}/>
                                            <div>{dateForm(shoka.shokaDate)}</div>
                                        </div>
                                        :
                                        <div className='membership_reserve_cancel_privilege full_width'>
                                            <PrivilegeIcon className={shoka.shokaKenriIro}/>
                                            <div>{value.senyuDatHyojiDaitaiStr}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )):null}
        </div>
    );
};